!((document, Drupal, $) => {
  'use strict';
  $(window).ready(function() {
    let threeColComponent = $('.three-column-informational-content-list');
    threeColComponent.each(function() {
      let ListItems = $(this).find('.row').children();
      let count = ListItems.length;
      var n = 0, col = 0;
      // When three column option selected.
      if (ListItems.hasClass('col-md-4')) {
        col = 3;
      }
      else if (ListItems.hasClass('col-md-6')) {
        col = 2;
      }
      if ($(window).width() > 767) {
        if (count % col > 0) {
          n = count % col == 1 ? count - 1 : count - 2;
        }
        else {
          if (count > col) {
            n = count - col;
          }
          else {
            n = 0;
          }
        } 
      }
      else {
        n = count - 1;
      }
      ListItems.slice(n).css('padding-bottom', '0');
    }); 
  });
})(document, Drupal, jQuery);
